import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  DatePicker,
  DatePickerProps,
  Drawer,
  Flex,
  Form,
  FormInstance,
  FormProps,
  Input,
  notification,
} from "antd";
import { Calendar, CallCalling, CloseCircle, Man, Woman } from "iconsax-react";
import dayjs from "dayjs";
import { mixGetV1, mixPostV1, mixPutV1 } from "../../../services/mixin";
import type { Dayjs } from "dayjs";
import { report } from "process";
import "./EditReportIncomePoup.scss";

const closeIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {" "}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.86312 3.86363C4.03189 3.6949 4.26077 3.60012 4.49942 3.60012C4.73806 3.60012 4.96694 3.6949 5.13572 3.86363L8.99942 7.72733L12.8631 3.86363C12.9461 3.77767 13.0455 3.7091 13.1553 3.66194C13.2651 3.61477 13.3832 3.58994 13.5027 3.5889C13.6222 3.58786 13.7407 3.61063 13.8513 3.65589C13.9619 3.70114 14.0624 3.76797 14.1469 3.85247C14.2314 3.93697 14.2982 4.03746 14.3435 4.14807C14.3887 4.25867 14.4115 4.37719 14.4104 4.49669C14.4094 4.61619 14.3846 4.73429 14.3374 4.84409C14.2902 4.95389 14.2217 5.0532 14.1357 5.13623L10.272 8.99993L14.1357 12.8636C14.2997 13.0334 14.3904 13.2607 14.3883 13.4967C14.3863 13.7327 14.2916 13.9584 14.1248 14.1253C13.9579 14.2921 13.7322 14.3868 13.4962 14.3888C13.2602 14.3909 13.0329 14.3002 12.8631 14.1362L8.99942 10.2725L5.13572 14.1362C4.96598 14.3002 4.73863 14.3909 4.50266 14.3888C4.26668 14.3868 4.04095 14.2921 3.87408 14.1253C3.70721 13.9584 3.61256 13.7327 3.61051 13.4967C3.60846 13.2607 3.69918 13.0334 3.86312 12.8636L7.72682 8.99993L3.86312 5.13623C3.69439 4.96745 3.59961 4.73857 3.59961 4.49993C3.59961 4.26128 3.69439 4.0324 3.86312 3.86363Z"
      fill="#6B7280"
    />{" "}
  </svg>
);

interface Props {
  item?: number;
  isShow?: boolean;
  onPopupClose?: () => void;
  onSuccess?: () => void;
}

type FieldType = {
  start_amount?: number;
  bonus_total?: number;
  extra?: number;
  final?: number;
  labor?: number;
  loss?: number;
  match_total?: number;
  money_in_proof?: number;
  money_of_system?: number;
  payout_total?: number;
  profit?: number;
  total_in?: number;
  listAddbank?: ListBankType[];
  final_show?: number;
  addbank?: number;
  zelle?: number;
  baccarat?: number;
};
type ListBankType = {
  action_name?: string;
  amount?: number;
  addbank_id?: number | null;
};

const EditReportIncomePoup: React.FC<Props> = (props) => {
  const { item, isShow = false, onPopupClose, onSuccess } = props;
  const [open, setOpen] = useState(isShow);
  const [infoReport, setInfoReport] = useState<FieldType | null>(null);
  const [listAddBank, setlistAddBank] = useState<ListBankType[]>([]);
  const [totalAddbank, setTotalAddbank] = useState<number>(0);
  const [numberMoneyInProof, setNumberMoneyInProof] = useState<number>(0);

  useEffect(() => {
    setOpen(isShow);

    if (isShow) {
      setConfirmLoading(false);
      gItemReport();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShow, item]);

  const onClose = () => {
    setOpen(false);
    if (onPopupClose) {
      onPopupClose();
    }
  };
  const gItemReport = async () => {
    if (item) {
      const res = await mixPostV1(
        "/api/webAdmin/gDetailreportTotalIncomeById.php",
        { report_id: item }
      );

      if (res.status === 1) {
        const data = res.data;
        setlistAddBank(data.listAddbank);
        setNumberMoneyInProof(data.money_in_proof);
        setInfoReport({
          ...data,
          final_show: data.money_of_system - data.addbank + (data.baccarat || 0),
        });
        setTimeout(() => {
          formRef.current?.setFieldsValue(data);
        }, 50);
      }
    }
  };

  // FORM SUBMIT
  const formRef = useRef<FormInstance<FieldType>>(null);
  const onSubmitForm = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  // FORM SUBMIT SUCCESSFULLY
  const [confirmLoading, setConfirmLoading] = useState(false);
  const handleOk = async (values: any) => {
    setConfirmLoading(true);
    const listAddbankData = listAddBank.filter(
      (item) => item.action_name && item.amount
    );
    if (listAddbankData.length === 0) {
      setConfirmLoading(false);
      openNotification("error", "Please add bank");
      return;
    }
    const params = {
      ...infoReport,
      listAddbank: JSON.stringify(listAddbankData),
    };

    try {
      const res = await mixPutV1(
        "/api/webAdmin/updateReportIncomeById.php",
        params
      );
      if (res.status === 1) {
        setConfirmLoading(false);
        onClose();
        openNotification();
        if (onSuccess) {
          onSuccess();
        }
      } else {
        setConfirmLoading(false);
        openNotification("error", res.message);
      }
    } catch (error) {
      setConfirmLoading(false);
      openNotification("error", "Oops, something went wrong!");
    }
  };

  const handleAddBankNew = () => {
    setlistAddBank([
      ...listAddBank,
      { action_name: "", amount: undefined, addbank_id: null },
    ]);
  };

  const handleRemoveAddbank = (index: number) => {
    setlistAddBank(listAddBank.filter((item, i) => i !== index));
  };

  const handleUpdateDetail = (index: number, value: string) => {
    setlistAddBank(
      listAddBank.map((item, i) =>
        i === index ? { ...item, action_name: value } : item
      )
    );
  };
  const handleUpdateAmountDetail = (
    index: number,
    value: number | undefined
  ) => {
    setlistAddBank(
      listAddBank.map((item, i) =>
        i === index ? { ...item, amount: value } : item
      )
    );
  };
  const onFinish: FormProps<FieldType>["onFinish"] = (values) => {
    handleOk(values);
  };

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Report updated!"
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  // POPUP FOOTER
  const Footer = (
    <>
      <Button className="rs-button default-outlined" onClick={onClose}>
        Close
      </Button>
      <Button
        type="primary"
        loading={confirmLoading}
        className="rs-button"
        onClick={onSubmitForm}
      >
        Update
      </Button>
    </>
  );
  const getTotalAddbank = () => {
    let total = 0;
    listAddBank.map((item) => {
      total += item?.amount ? Number(item?.amount) : 0;
    });
    setTotalAddbank(total);
    setInfoReport({
      ...infoReport,
      listAddbank: listAddBank,
      start_amount: total,
      addbank: total,
    });
  };

  const renderData = () => {
    let finalNumber =
      Number(totalAddbank) -
      Number(infoReport?.bonus_total) -
      Number(infoReport?.labor) -
      Number(infoReport?.extra) -
      Number(infoReport?.match_total) -
      Number(infoReport?.payout_total);
    let money_system = Number(infoReport?.total_in) + Number(finalNumber);
    let loss = Number(numberMoneyInProof) - money_system;
    let finalShow = money_system - totalAddbank + (infoReport?.baccarat || 0);
    formRef.current?.setFieldsValue({
      money_of_system: money_system,
      loss: loss,
      final_show: finalShow,
    });
    setInfoReport({
      ...infoReport,
      money_of_system: money_system,
      money_in_proof: numberMoneyInProof,
      loss: loss,
      final: finalNumber,
    });
  };
  useEffect(() => {
    renderData();
  }, [totalAddbank, numberMoneyInProof]);
  useEffect(() => {
    getTotalAddbank();
  }, [listAddBank]);
  return (
    <>
      {contextHolder}

      <Drawer
        title="Edit Staff Info"
        rootClassName="rs-drawer w-338 footer-with-2-button"
        open={open}
        footer={Footer}
        closeIcon={closeIcon}
        onClose={onClose}
      >
        <div className="flex w-full justify-between border-b border-[#333] items-center py-[15px]">
          <div>
            <p className="font-satoshi text-[#FFFFFF] text-[16px] font-normal">
              Bank
            </p>
          </div>
          <button
            className="text-[#F9D361] border-solid border-[1px] border-[#272727] rounded-md px-3 py-1 text-[14px] font-satoshi focus:outline-none transition"
            onClick={handleAddBankNew}
          >
            + Add
          </button>
        </div>
        <Form
          ref={formRef}
          onFinish={onFinish}
          autoComplete="off"
          className="rs-form"
          layout="vertical"
          requiredMark={false}
        >
          {listAddBank.length > 0 &&
            listAddBank.map((item, i) => (
              <div
                key={`l${i}`}
                className="flex w-full justify-between pt-2 ml-3 border-b border-[#333] py-[15px] div-action"
              >
                <div className="h-5 w-[100px]">
                  <input
                    type="text"
                    className="rs-input flex justify-center items-center custom-input-bank"
                    placeholder="actione name..."
                    value={
                      item.action_name !== undefined
                        ? item.action_name?.toString()
                        : ""
                    }
                    onChange={(e) => {
                      if (e.target.value.length > 100) {
                        return;
                      }
                      handleUpdateDetail(i, e.target.value);
                    }}
                  />
                </div>
                <div className="flex gap-1 items-center">
                  <div className="h-5 w-[80px]">
                    <input
                      type="number"
                      className="rs-input flex justify-center items-center custom-input-bank"
                      placeholder="Click to edit"
                      value={
                        item.amount !== undefined ? item.amount?.toString() : ""
                      }
                      onChange={(e) => {
                        if (e.target.value.length > 18) {
                          return;
                        }
                        const value = Number(e.target.value);
                        if (value < 0) return;
                        handleUpdateAmountDetail(i, value);
                      }}
                    />
                  </div>

                  <Button
                    className="m-5"
                    type="text"
                    danger
                    size="small"
                    icon={<CloseCircle />}
                    onClick={() => handleRemoveAddbank(i)}
                  />
                </div>
              </div>
            ))}

          <div className="flex justify-end text-sm text-white font-bold mt-2">
            <span> ${totalAddbank}</span>
          </div>
          <Form.Item<FieldType>
            label="Bank"
            name="start_amount"
            hidden
            rules={[{ required: true, message: "This field must be filled!" }]}
          >
            <Input
              placeholder="Start amount"
              className="rs-input"
              type="number"
            />
          </Form.Item>
          <Form.Item<FieldType>
            label="Cash on hand"
            name="money_in_proof"
            rules={[{ required: true, message: "This field must be filled!" }]}
          >
            <Input
              placeholder="Cash on hand"
              className="rs-input"
              type="number"
              value={numberMoneyInProof.toString()}
              onChange={(e) => setNumberMoneyInProof(Number(e.target.value))}
            />
          </Form.Item>
          <Form.Item<FieldType> label="Profit machine" name="profit">
            <Input
              placeholder="Profit machine"
              className="rs-input"
              type="number"
              readOnly
            />
          </Form.Item>

          <Form.Item<FieldType> label="Money of system" name="money_of_system">
            <Input
              placeholder="Money of system"
              className="rs-input"
              type="number"
              readOnly
            />
          </Form.Item>

          <Form.Item<FieldType> label="Loss" name="loss">
            <Input
              placeholder="Loss"
              className="rs-input"
              type="number"
              readOnly
            />
          </Form.Item>
          <Form.Item<FieldType> label="Final" name="final_show">
            <Input
              placeholder="Final"
              className="rs-input"
              type="number"
              readOnly
            />
          </Form.Item>
          <Form.Item<FieldType> label="Bonus" name="bonus_total">
            <Input
              placeholder="Bonus"
              className="rs-input"
              type="number"
              readOnly
            />
          </Form.Item>
          <Form.Item<FieldType> label="Labor" name="labor">
            <Input
              placeholder="Labor"
              className="rs-input"
              type="number"
              readOnly
            />
          </Form.Item>
          <Form.Item<FieldType> label="extra" name="extra">
            <Input
              placeholder="extra"
              className="rs-input"
              type="number"
              readOnly
            />
          </Form.Item>
          <Form.Item<FieldType> label="Payout of system" name="payout_total">
            <Input
              placeholder="Payout of system"
              className="rs-input"
              type="number"
              readOnly
            />
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

export default EditReportIncomePoup;

